// DishMacros (v5.14.8) — a compact one-line macro strip (calories / protein /
// carbs / fat) read from a meal item's stored nutritional_info. Used under the
// dish name in the meal-pass purchase pickers. Renders nothing when the dish
// has no nutrition, so it never leaves an empty row.
import React from 'react';

const MACROS = [
  { key: 'calories', suffix: ' cal', short: '' },
  { key: 'protein', suffix: 'g', short: 'P' },
  { key: 'carbs', suffix: 'g', short: 'C' },
  { key: 'fat', suffix: 'g', short: 'F' },
];

export default function DishMacros({ nutrition, className = '' }) {
  const n = nutrition || {};
  const parts = MACROS
    .map((m) => ({ ...m, val: n[m.key] }))
    .filter((m) => m.val != null && m.val !== '' && Number(m.val) > 0)
    .map((m) => `${m.val}${m.suffix}${m.short ? ` ${m.short}` : ''}`);
  if (parts.length === 0) return null;
  return (
    <span className={`block text-[10px] text-slate-400 truncate ${className}`}
      data-testid="dish-macros">
      {parts.join(' · ')}
    </span>
  );
}
